import { Divider, FormControl, FormLabel, Grid, Paper, Radio, RadioGroup, Typography } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import { Formik, Form, Field } from "formik";
import React, { useCallback, useEffect, useState } from 'react';
import { FormControlLabel, Checkbox, Button } from "@mui/material";
import Div from '@jumbo/shared/Div';

function SingleStockCount() {
  const [params, setParams] = useState(null)
  const init = async () => {
    await jwtAuthAxios.get('stk').then(res => setParams(res.data))
  }
  useEffect(() => {
    init()
  }, [])
  if (params == null) {
    return 'Loading.......'
  }
  // const CheckboxGroup = ({ label, options, name, values, setFieldValue }) => {
  //     const handleChange = (event) => {
  //       const value = event.target.name;
  //       if (event.target.checked) {
  //         setFieldValue(name, [...values, value]);
  //       } else {
  //         setFieldValue(name, values.filter((item) => item !== value));
  //       }
  //     };

  //     return (
  //       <div>
  //         <Typography>{label}</Typography>
  //         <Grid container spacing={1}>
  //           {options?.map((option) => (
  //             <Grid item xs={6} md={4} key={option.NAME}>
  //               <FormControlLabel
  //                 control={
  //                   <Checkbox
  //                     name={option.NAME}
  //                     checked={values.includes(option.NAME)}
  //                     onChange={handleChange}
  //                   />
  //                 }
  //                 label={option.NAME}
  //               />
  //             </Grid>
  //           ))}
  //         </Grid>
  //         <Divider sx={{ my: 2 }} />
  //       </div>
  //     );
  //   };
  const CheckboxGroup = ({ label, options, name, values, setFieldValue }) => {
    const handleChange = (event) => {
      const value = event.target.name;
      if (event.target.checked) {
        setFieldValue(name, [...values, value]);
      } else {
        setFieldValue(name, values.filter((item) => item !== value));
      }
    };

    const handleSelectAll = (event) => {
      if (event.target.checked) {
        // Select all options
        setFieldValue(name, options.map((option) => option.NAME));
      } else {
        // Deselect all options
        setFieldValue(name, []);
      }
    };

    const isAllSelected = values.length === options.length;

    return (
      <div>

        <Grid container spacing={1}>
          {/* Select All Checkbox */}
          <Grid item xs={6}>
            <Typography variant='h3'>{label}</Typography>
          </Grid>
          <Grid item xs={6} sx={{ textAlign: 'end' }} alignItems={'end'}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={values.length > 0 && values.length < options.length}
                  onChange={handleSelectAll}
                />
              }
              label="Select All"
            />
          </Grid>
          <Divider />

          {/* Individual Checkboxes */}
          {options.map((option) => (
            <Grid item xs={6} md={4} key={option.NAME}>
              <FormControlLabel
                control={
                  <Checkbox
                    name={option.NAME}
                    checked={values.includes(option.NAME)}
                    onChange={handleChange}
                  />
                }
                label={option.NAME}
              />
            </Grid>
          ))}

        </Grid>
        <Divider sx={{ my: 2 }} />
      </div>
    );
  };


  return (
    <Grid container>
      <Grid item xs={12}>
        <h2>Single Stock Count</h2>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          <Formik
            initialValues={{
              shape: [],
              lab: [],
              totalFlg: 1,
              metrix:1,
              status: [],
            }}
            onSubmit={async (values) => {
              // await jwtAuthAxios.post('stk/stkcount',values).then(res => console.log(res.data))
              try {
                const response = await jwtAuthAxios.post('stk/stkcount', values, {
                  responseType: 'blob', // Ensures the response is treated as a file
                });

                // Create a blob URL
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);

                // Create an anchor element and trigger the download
                const link = document.createElement('a');
                link.href = url;

                // Extract file name from headers or set a default name
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'metrix-' + values.lab.join('-') + values.status.join('-') + '.xlsx';
                if (contentDisposition) {
                  const match = contentDisposition.match(/filename="?(.+)"?/);
                  if (match) fileName = match[1];
                }
                link.download = fileName;

                document.body.appendChild(link);
                link.click();

                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);

                console.log('File downloaded successfully.');
              } catch (error) {
                console.error('Error downloading the file:', error);
              }
              // console.log("Form Values:", values);
            }}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Grid container spacing={2}>
                  {/* <Grid item xs={12}>
              <Typography variant="h4">Single Stock Count</Typography>
            </Grid> */}
                  <Grid item xs={12}>
                    <Div >
                      <CheckboxGroup
                        label="Shape"
                        options={params?.shape || []}
                        name="shape"
                        values={values?.shape}
                        setFieldValue={setFieldValue}
                      />
                      <CheckboxGroup
                        label="Lab"
                        options={params?.lab}
                        name="lab"
                        values={values.lab}
                        setFieldValue={setFieldValue}
                      />
                      <CheckboxGroup
                        label="Status"
                        options={params?.status}
                        name="status"
                        values={values?.status}
                        setFieldValue={setFieldValue}
                      />
                      <FormControl component="fieldset">
                        <FormLabel component="legend">Select Metrix Option</FormLabel>
                        <RadioGroup
                          row
                          value={values.metrix} // Controlled by Formik
                          onChange={(e) => setFieldValue('metrix', e.target.value)} // Update Formik value
                        >
                          <FormControlLabel
                            value="1" // Matches Formik initial value type
                            control={<Radio />}
                            label="Metrix 1"
                          />
                          <FormControlLabel
                            value="2" // Matches Formik initial value type
                            control={<Radio />}
                            label="metrix 2"
                          />
                        </RadioGroup>
                      </FormControl>
                      <Divider sx={{ my: 2 }} />

                      <FormControl component="fieldset">
                        <FormLabel component="legend">Select Total Option</FormLabel>
                        <RadioGroup
                          row
                          value={values.totalFlg} // Controlled by Formik
                          onChange={(e) => setFieldValue('totalFlg', e.target.value)} // Update Formik value
                        >
                          <FormControlLabel
                            value="0" // Matches Formik initial value type
                            control={<Radio />}
                            label="With Total"
                          />
                          <FormControlLabel
                            value="1" // Matches Formik initial value type
                            control={<Radio />}
                            label="Without Total"
                          />
                        </RadioGroup>
                      </FormControl>


                      <Divider sx={{ my: 2 }} />
                      <Button type="submit" variant="contained" color="primary">
                        Export Excel
                      </Button>
                    </Div>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
          {/* <Typography>Shape</Typography>
       {JSON.stringify(params?.shape)}
<Divider/>
       <Typography>Lab</Typography>
       {JSON.stringify(params?.lab)}
<Divider/>
       <Typography>Status</Typography>
       {JSON.stringify(params?.lab)} */}
        </Paper>
      </Grid>
    </Grid>
  );
}



SingleStockCount.Modulename = 'StockSingeCount';

export default SingleStockCount;
